import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=1f4c8dd0&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=1f4c8dd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c8dd0",
  null
  
)

export default component.exports